import { render } from "./WantedPeople.vue?vue&type=template&id=32a65a56&scoped=true"
import script from "./WantedPeople.vue?vue&type=script&lang=js"
export * from "./WantedPeople.vue?vue&type=script&lang=js"

import "./WantedPeople.vue?vue&type=style&index=0&id=32a65a56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a65a56"]])

export default __exports__